<div class="bg-white">
  <div class="border-bottom p-4">
    <h3 class="pt-2">{{ 'Sellers.Products.Contract' | translate }}</h3>
  </div>

  <div class="p-4">
    <!-- start page 1 -->
    <div class="page-1 w-100">
      <form *ngIf="page1Form" class="row" [formGroup]="page1Form">
        <div class="col-12 mb-3">
          <div class="form-group">
            <h5>{{ 'Sellers.Products.ContractDeliveryAddress' | translate }} <span class="text-danger">*</span></h5>
            <div class="row">
              <div class="col-md-3" *ngIf="ViewRequestFlag">
                <label>{{ 'Sellers.Products.Governorate' | translate }}</label>
                <input type="text" placeholder="{{ 'Sellers.Products.Governorate' | translate }}"
                       [formControl]="convertPage1Controls('contractDeliveryGovernate')" class="form-control">
                <small class="text-danger" *ngIf="fvPage1.formErrors.contractDeliveryGovernate">
                  {{ fvPage1.formErrors.contractDeliveryGovernate }}
                </small>
              </div>
              <div class="col-md-3" *ngIf="!ViewRequestFlag">
                <label>{{ 'Sellers.Products.Governorate' | translate }}</label>
                <select class="form-control form-select" [formControl]="convertPage1Controls('contractDeliveryGovernate')">
                  <option value="null" disabled selected>{{ 'Sellers.Products.SelectGovernorate' | translate }}</option>
                  <option *ngFor="let city of cities" [value]="city.city">{{ city.city }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <label>{{ 'Sellers.Products.Area' | translate }}</label>
                <input type="text" placeholder="{{ 'Sellers.Products.Area' | translate }}" [formControl]="convertPage1Controls('contractDeliveryArea')" class="form-control">
                <small class="text-danger" *ngIf="fvPage1.formErrors.contractDeliveryArea">
                  {{ fvPage1.formErrors.contractDeliveryArea }}
                </small>
              </div>
              <div class="col-md-6">
                <label>{{ 'Sellers.Products.Address' | translate }}</label>
                <input type="text" placeholder="{{ 'Sellers.Products.Address' | translate }}" [formControl]="convertPage1Controls('contractDeliveryAddress')" class="form-control">
                <small class="text-danger" *ngIf="fvPage1.formErrors.contractDeliveryAddress">
                  {{ fvPage1.formErrors.contractDeliveryAddress }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="form-group" *ngIf="!ViewRequestFlag">
            <label>{{ 'Sellers.Products.ContractDeliveryDuration' | translate }} <span class="text-danger">*</span></label>
            <select class="form-control form-select" [formControl]="convertPage1Controls('contractDeliveryDuration')">
              <option value="3">3</option>
              <option value="5">5</option>
            </select>
          </div>
          <div class="form-group" *ngIf="ViewRequestFlag">
            <label>{{ 'Sellers.Products.ContractDeliveryDuration' | translate }} <span class="text-danger">*</span></label>
            <input type="text" [formControl]="convertPage1Controls('contractDeliveryDuration')" class="form-control">
          </div>
        </div>

        <div class="col-6 mb-3" *ngIf="ViewRequestFlag">
          <div class="form-group">
            <label>{{ 'Sellers.Products.ContractStatus' | translate }} </label>
            <input type="text" [formControl]="contractStatus" class="form-control" readonly>
          </div>
        </div>
      </form>
    </div>
    <!-- start page 2-->
    <div class="page-2 w-100" *ngIf="hasBusinessRegistered === true">
      <form class="row" [formGroup]="page2Form">
        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.ExactBusinessName' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [formControl]="convertPage2Controls('exactRegisterName')"
                 placeholder="{{ 'Sellers.Products.ExactBusinessName' | translate }}">
          <small class="text-danger" *ngIf="fvPage2.formErrors.exactRegisterName">
            {{ fvPage2.formErrors.exactRegisterName }}
          </small>
        </div>
        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.CommercialRegisterNumber' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
                 placeholder="{{ 'Sellers.Products.CommercialRegisterNumber' | translate }}"
                 [formControl]="convertPage2Controls('commericalRegisterNumber')">
          <small class="text-danger" *ngIf="fvPage2.formErrors.commericalRegisterNumber">
            {{ fvPage2.formErrors.commericalRegisterNumber }}
          </small>
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.RegisteredBusinessAddress' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="{{ 'Sellers.Products.RegisteredBusinessAddress' | translate }}"
                 [formControl]="convertPage2Controls('registeredBusinessAddress')">
          <small class="text-danger" *ngIf="fvPage2.formErrors.registeredBusinessAddress">
            {{ fvPage2.formErrors.registeredBusinessAddress }}
          </small>
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.TaxRegistrationNumber' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="{{ 'Sellers.Products.TaxRegistrationNumber' | translate }}"
                 [formControl]="convertPage2Controls('taxRegistrationNumber')"
				 (keyup)="formatTaxRegistrationNumber()"
				 >
          <small class="text-danger" *ngIf="fvPage2.formErrors.taxRegistrationNumber">
            {{ fvPage2.formErrors.taxRegistrationNumber }}
          </small>
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.BusinessOwnerFullName' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
                 placeholder="{{ 'Sellers.Products.BusinessOwnerFullName' | translate }}"
                 [formControl]="convertPage2Controls('businessOwnerFullName')">
          <small class="text-danger" *ngIf="fvPage2.formErrors.businessOwnerFullName">
            {{ fvPage2.formErrors.businessOwnerFullName }}
          </small>
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ 'Sellers.Products.BusinessOwnerNationalIdNumber' | translate }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control"
                 placeholder="{{ 'Sellers.Products.BusinessOwnerNationalIdNumber' | translate }}"
                 [formControl]="convertPage2Controls('businessOwnerNationalID')">
          <small class="text-danger" *ngIf="fvPage2.formErrors.businessOwnerNationalID">
            {{ fvPage2.formErrors.businessOwnerNationalID }}
          </small>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>{{ 'Sellers.Products.BusinessName' | translate }} <span class="text-danger">*</span></label>
            <input  type="text" class="form-control"
                    placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
                    [formControl]="convertPage2Controls('businessName')" >
            <small class="text-danger" *ngIf="fvPage2.formErrors.businessName">
              {{ fvPage2.formErrors.businessName }}
            </small>
          </div>
        </div>


        <div *ngIf="ViewRequestFlag" class="form-group mb-3 col-md-6">
          <label>{{ 'Sellers.Products.DownloadTaxCard' | translate }} </label>
          <button (click)="download(ViewRequestData.taxCard , 'taxCard')"
                  class="btn btn-sm btn-success ms-2">
            {{ 'Sellers.Products.Download' | translate }}
          </button>
        </div>

        <div *ngIf="ViewRequestFlag" class="form-group mb-3 col-md-6">
          <label>{{ 'Sellers.Products.DownloadCommercialRegister' | translate }} </label>
          <button (click)="download(ViewRequestData.commercialRegister , 'commercialRegister')"
                  class="btn btn-sm btn-success ms-2">
            {{ 'Sellers.Products.Download' | translate }}
          </button>
        </div>

      </form>
    </div>
    <!-- start page 3-->
    <div class="page-3 w-100" *ngIf="hasBusinessRegistered === false">
      <form class="row" [formGroup]="page3Form">
        <div class="col-4 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.BusinessName' | translate }} <span class="text-danger">*</span></label>
            <input [disabled]="ViewRequestFlag" placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
                   [formControl]="convertPage3Controls('businessName')" class="form-control">
            <small class="text-danger" *ngIf="fvPage3.formErrors.businessName">
              {{ fvPage3.formErrors.businessName }}
            </small>
          </div>
        </div>

        <div class="col-4 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.FullName' | translate }} <span class="text-danger">*</span></label>
            <input [disabled]="ViewRequestFlag"
                   placeholder="{{ 'Sellers.Products.FullName' | translate }}"
                   [formControl]="convertPage3Controls('fullName')" class="form-control">
            <small class="text-danger" *ngIf="fvPage3.formErrors.fullName">
              {{ fvPage3.formErrors.fullName }}
            </small>
          </div>
        </div>

        <div class="col-4 mb-3">
          <div class="form-group">
            <label>{{ 'Sellers.Products.NationalIDNumber' | translate }} <span class="text-danger">*</span></label>
            <input [disabled]="ViewRequestFlag"
                   placeholder="{{ 'Sellers.Products.NationalIDNumber' | translate }}"
                   [formControl]="convertPage3Controls('nationalID')" class="form-control">
            <small class="text-danger" *ngIf="fvPage3.formErrors.nationalID">
              {{ fvPage3.formErrors.nationalID }}
            </small>
          </div>
        </div>

        <div *ngIf="ViewRequestFlag" class="form-group mb-3 col-md-6">
          <label>
            {{ 'Sellers.Products.DownloadIDBack' | translate }}:
          </label>
          <button (click)="download(ViewRequestData.personalIdBack , 'personalIdBack')"
                  class="btn btn-sm btn-success ms-2">
            {{ 'Sellers.Products.Download' | translate }}
          </button>
        </div>

        <div *ngIf="ViewRequestFlag" class="form-group mb-3 col-md-6">
          <label>{{ 'Sellers.Products.DownloadIDFront' | translate }}: </label>
          <button (click)="download(ViewRequestData.personalIdFront , 'personalIdFront')"
                  class="btn btn-sm btn-success ms-2">
            {{ 'Sellers.Products.Download' | translate }}
          </button>
        </div>
      </form>
    </div>
    <!-- end page 3 -->
    <div *ngIf="!ViewRequestFlag" class="col-12 mb-3">
      {{ 'Sellers.Products.ContactLogistics' | translate }}: <strong style="color: #121270;">CustomerSupportPhone</strong>
    </div>

    <div *ngIf="ViewRequestFlag" class="form-group mb-3 col-md-6 offset-md-3 download-contract">
      <label>{{ 'Sellers.Products.DownloadAutoGeneratedContract' | translate }}: </label>
      <button (click)="exportAs('word')" class="btn btn-sm btn-success ms-2">
        {{ 'Sellers.Products.Download' | translate }}
      </button>
    </div>

    <!-- <div class="alert alert-success bottom mb-3 row mx-0" role="alert" *ngIf="showContractAlert">
      <div class="d-flex justify-content-end mb-3">
        <span class="material-icons alertb col-auto" (click)="showContractAlert=false">
          {{ 'Sellers.Products.Cancel' | translate }}
        </span>
      </div>
      <span class="col-12">
        <strong>{{ 'Sellers.Products.ThankYou' | translate }},</strong> {{ 'Sellers.Products.ContractDraftDownloaded' | translate }}
      </span>
      <div class="d-flex justify-content-between mb-3">
        <button type="button" class="btn btn-primary col-auto py-1" (click)="nextOrSubmit()">
          {{ 'Sellers.Products.Download' | translate }}
        </button>
        <button type="button" class="btn btn-primary col-auto py-1" (click)="confirmContract()">
          {{ 'Sellers.Products.Confirm' | translate }}
        </button>
      </div>
    </div> -->
    <div *ngIf="saveError" class="p-2 text-danger ms-2">
      <p>{{ saveError }}</p>
    </div>
  </div>

  <div class="border-top p-4">
    <div class="d-flex justify-content-between">
      <div class="col-auto">
      <button *ngIf="ViewRequestFlag" [disabled]="isContractSubmitted" class="btn btn-primary" (click)="requestEdit()">Request Edit</button>
      </div>
      <div class="ms-auto col-auto">
        <button *ngIf="ViewRequestFlag" (click)="nextOrSubmit()" class="btn btn-primary">
          {{ 'Sellers.Products.Submit' | translate }}
        </button>
        <button *ngIf="ViewRequestFlag" [disabled]="!RequestIsPending || contractStatus.value!='confirmed'"
          (click)="accept('shipped')" class="btn btn-primary float-left mx-2">
          {{ 'Sellers.Products.Shipped' | translate }}
        </button>
        <button *ngIf="ViewRequestFlag" [disabled]="!RequestIsPending || contractStatus.value!='shipped'"
                (click)="accept('signed')" class="btn btn-primary">
          {{ 'Sellers.Products.Sign' | translate }}
        </button>
      </div>
    </div>
    <br>
    <div *ngIf="ViewRequestFlag" class="col-auto d-flex justify-content-between">
      <button (click)="nextOrPrevious('prev')" class="btn btn-primary mb-2 col-md-2">
        < {{ 'Sellers.Products.PreviousContract' | translate }}
      </button>
      <button (click)="nextOrPrevious('next')" class="btn btn-primary mb-2 col-md-2 float-end">
        {{ 'Sellers.Products.NextContract' | translate }} >
      </button>
    </div>
  </div>
</div>
